import { z } from "zod";

export const stripeKeyModeEnumSchema = z.enum(["test", "live"]);
export type StripeKeyModeType = z.infer<typeof stripeKeyModeEnumSchema>;

export const subscribablePlansEnumSchema = z.enum(["business", "enterprise"]);
export type SubscribablePlanType = z.infer<typeof subscribablePlansEnumSchema>;

export const planFrequencyEnumSchema = z.enum(["yearly", "monthly"]);
export type PlanFrequencyType = z.infer<typeof planFrequencyEnumSchema>;

export const checkoutPlanPriceSchema = z.object({
  priceCents: z.number(),
  stripePriceId: z.string(),
  currencyCode: z.string(),
  frequency: planFrequencyEnumSchema,

  discountedIntroTerm: z
    .object({
      priceCents: z.number(),
      duration: z.number(),
    })
    .nullish(),
});
export type CheckoutPlanPriceType = z.infer<typeof checkoutPlanPriceSchema>;

export const checkoutPlanInfoSchema = z.object({
  name: subscribablePlansEnumSchema,
  displayName: z.string(),
  stripeProductId: z.string(),
  includedCreditsAmount: z.number(),
  includedSeatsAmount: z.number(),

  prices: z.array(checkoutPlanPriceSchema),
});
export type CheckoutPlanInfoType = z.infer<typeof checkoutPlanInfoSchema>;

export const paymentMethodDetailsSchema = z.object({
  id: z.string(),
  type: z.string(),

  cardDetails: z
    .object({
      last4: z.string(),
      brand: z.string(),
      expMonth: z.number(),
      expYear: z.number(),
    })
    .nullable(),
});
export type PaymentMethodDetailsType = z.infer<typeof paymentMethodDetailsSchema>;

export const getCheckoutInfoResponseSchema = z.object({
  plans: z.array(checkoutPlanInfoSchema),

  credits: z.object({
    priceCents: z.number(),
  }),

  seats: z.object({
    priceCents: z.number(),
  }),

  paymentMethodDetails: paymentMethodDetailsSchema.nullable(),
});
export type GetCheckoutInfoResponseType = z.infer<typeof getCheckoutInfoResponseSchema>;
